const AboutIndex = () => {
    return <div>
        <iframe src="https://taro.jefftian.dev/pages/subpages/github/readme"
                style={{width: '100%', height: '100vh', border: 'none', marginTop: '-60px'}}/>
    </div>
}

export default AboutIndex;
